/**
 * @prettier
 */
import React from "react";
import { UserManagementPage } from "./UserManagement";

export default React.memo(UserManagementPage);
